'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoCode = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.context = context;
    this.els = {
      el: el,
      trigger: context.getElement('.' + context.className + '_Trigger'),
      iconPlus: context.getElement('.' + context.className + '_TriggerIcon-plus'),
      iconMinus: context.getElement('.' + context.className + '_TriggerIcon-minus'),
      sourceInput: context.getElement('.' + context.className + '_Input-source')
    };

    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.methods.setCookie = this.methods.setCookie.bind(this);
    this.methods.getCookie = this.methods.getCookie.bind(this);
    this.methods.populatePromoCode = this.methods.populatePromoCode.bind(this);

    this.cookieName = 'promo_code';
    this.cookieValue = this.methods.getCookie(this.cookieName);

    this.methods.populatePromoCode();
    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    var _this = this;

    this.els.trigger.addEventListener('click', function (e) {
      var isExpanded = _this.els.el.getAttribute('aria-expanded');

      if (isExpanded === 'true') {
        _this.els.el.setAttribute('aria-expanded', 'false');
        _this.els.iconPlus.setAttribute('aria-hidden', 'false');
        _this.els.iconMinus.setAttribute('aria-hidden', 'true');
      } else {
        _this.els.el.setAttribute('aria-expanded', 'true');
        _this.els.iconPlus.setAttribute('aria-hidden', 'true');
        _this.els.iconMinus.setAttribute('aria-hidden', 'false');
      }
    });

    this.els.sourceInput.addEventListener('blur', function (e) {
      _this.methods.setCookie(_this.cookieName, e.target.value, 1);
    });
  },


  methods: {
    populatePromoCode: function populatePromoCode() {
      if (this.cookieValue != null) {
        this.els.sourceInput.value = this.cookieValue;
      }
    },
    setCookie: function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    },
    getCookie: function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    }
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var promoCode = (0, _create2.default)(PromoCode);
  promoCode.init({ el: el, context: context });
}